import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import ExpeditionScheduleRoutes from "../ScheduleWorkingRoutes";
import { expeditionRoutes } from "../../../router/routesConstants";
import { useNavigate } from "react-router-dom";

function RoutesOrganizationLocal() {
  const navigate = useNavigate();
  const handleButtonPress = () => {
    navigate(`/${expeditionRoutes.routesOrganizationInternode}`);
  };

  return (
    <>
      <ContentCard cardBodyClassName="flex">
        <CustomButton
          variant={"contained"}
          className="min-w-0 flex-1"
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}>
          Rute locale
        </CustomButton>
        <CustomButton
          variant={"outlined"}
          className="min-w-0 flex-1"
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}
          onClick={handleButtonPress}>
          Rute internod
        </CustomButton>
      </ContentCard>
      <ExpeditionScheduleRoutes />
    </>
  );
}

export default RoutesOrganizationLocal;
